import { Box, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"

export function SkillMapViewHeader() {
    return (
        <ListItemBox sx={{ bgcolor: "background.neutral", borderRadius: 1, px: 2, py: 1.5, gap: 2 }}>
            <Box sx={{ width: 200, flexShrink: 0 }}>
                <Typography variant="subtitle2" color="text.secondary">
                    Trades
                </Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" color="text.secondary">
                    Skills
                </Typography>
            </Box>
        </ListItemBox>
    )
}
